import React, { useState, useEffect } from 'react';
import { BackendURL } from '../utils/BackendURL';
import axios from 'axios';
import PuffLoader from "react-spinners/PuffLoader";
import LoginProtoPage from '../MyComponents/LoginProtoPage';
import { ToggleDarkMode } from '../assets/js/darkmode';
import { fetchOrders } from '../apis/cartApis';
import { useLoading } from '../assets/js/ContextProviders/LoadingContext';
import { fetchDataDB, handleSubmit, retrieveData } from '../apis/dataService';
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import DefaultImg from '../Images/Products/Default.png';
import CartCard from '../MyComponents/CartCard';
import { useNavigate } from 'react-router-dom';

export default function Orders() {
    const { loading, startLoading, stopLoading } = useLoading();
    const { GetEmail, Account } = useAccount();
    console.log(GetEmail())

    // FETCH DATA FROM DB AND SAVE IT IN setOrders:
    const [Orders, setOrders] = useState([]);
    const fetchData = async () => {
        startLoading();
        try {
            const products = await retrieveData({
                var: GetEmail(),
                api: '/orders'
            });
            console.log("products:", products)
            setOrders(products);
            console.log("Cart PRODUCTS ", Orders)
            stopLoading();
        } catch (error) {
            console.error('Error fetching data:', error);
            stopLoading();
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    //SHOW ITEMS ON CLICKING SHOWITEM BTN:
    const [expandedOrders, setExpandedOrders] = useState({});

    const toggleItems = (orderId) => {
        setExpandedOrders((prev) => ({
            ...prev,
            [orderId]: !prev[orderId],
        }));
    };

    // NAVIGATES TO PRODUCTS IF NO ORDER:
    const navigate = useNavigate();

    const handleContinueShopping = () => {
        navigate('/products');
    };

    return (
        <>
            <div className="orders-parentdiv">
                <div className="orderstitle">ORDERS</div>
                <div className="orders-div">
                    {Orders.length === 0 && !loading ? (
                        <div className="no-orders-container">
                            <h2 className="no-orders-title">No Orders Placed</h2>
                            <p className="no-orders-message">Looks like you haven't placed any orders yet.</p>
                            <button className="continue-shopping-button" onClick={handleContinueShopping}>
                                Continue Shopping
                            </button>
                        </div>
                    ) : (
                        <>
                            {/* ORDERS PLACED */}
                            {Orders.some(order => order.status === 'email' || order.status === 'Placed') && (
                                <div className="order-placed">
                                    <div className="orders-card-title">ORDER PLACED:</div>
                                    {Orders.filter(order => order.status === 'email' || order.status === 'Placed').map((order, index) => (
                                        <div key={order._id || index} className="order-card">
                                            <div className="orders-content">
                                                <div><strong>Order ID:</strong> {order._id}</div>
                                                <div><strong>Name:</strong> {order.name || 'No name provided'}</div>
                                                <div><strong>Address:</strong> {order.address || 'No address provided'}</div>
                                                <div><strong>Total Items:</strong> {order.orders.length}</div>
                                            </div>
                                            <div className="orders-details">
                                                <div
                                                    className="orders-showItems"
                                                    onClick={() => toggleItems(order._id || index)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {expandedOrders[order._id || index] ? 'Hide Items' : 'Show Items'}
                                                </div>
                                                {expandedOrders[order._id || index] && (
                                                    <div className="orders-lists">
                                                        {order.orders.map((item, idx) => (
                                                            <div key={idx} className="order-item">
                                                                <div><strong>Item Name:</strong> {item.name || 'N/A'}</div>
                                                                <div><strong>Quantity:</strong> {item.Quantity || 0}</div>
                                                                <div><strong>Price:</strong> Rs. {item.price || 0}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* ORDERS SHIPPED */}
                            {Orders.some(order => order.status === 'shipped') && (
                                <div className="order-shipped">
                                    <div className="orders-card-title">ORDER SHIPPED:</div>
                                    {Orders.filter(order => order.status === 'shipped').map((order, index) => (
                                        <div key={order._id || index} className="order-card">
                                            <div className="orders-content">
                                                <div><strong>Order ID:</strong> {order._id}</div>
                                                <div><strong>Name:</strong> {order.name || 'No name provided'}</div>
                                                <div><strong>Address:</strong> {order.address || 'No address provided'}</div>
                                                <div><strong>Total Items:</strong> {order.orders.length}</div>
                                            </div>
                                            <div className="orders-details">
                                                <div
                                                    className="orders-showItems"
                                                    onClick={() => toggleItems(order._id || index)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {expandedOrders[order._id || index] ? 'Hide Items' : 'Show Items'}
                                                </div>
                                                {expandedOrders[order._id || index] && (
                                                    <div className="orders-lists">
                                                        {order.orders.map((item, idx) => (
                                                            <div key={idx} className="order-item">
                                                                <div><strong>Item Name:</strong> {item.name || 'N/A'}</div>
                                                                <div><strong>Quantity:</strong> {item.Quantity || 0}</div>
                                                                <div><strong>Price:</strong> Rs. {item.price || 0}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* ORDERS DELIVERED */}
                            {Orders.some(order => order.status === 'delivered') && (
                                <div className="order-shipped">
                                    <div className="orders-card-title">ORDER DELIVERED:</div>
                                    {Orders.filter(order => order.status === 'delivered').map((order, index) => (
                                        <div key={order._id || index} className="order-card">
                                            <div className="orders-content">
                                                <div><strong>Order ID:</strong> {order._id}</div>
                                                <div><strong>Name:</strong> {order.name || 'No name provided'}</div>
                                                <div><strong>Address:</strong> {order.address || 'No address provided'}</div>
                                                <div><strong>Total Items:</strong> {order.orders.length}</div>
                                            </div>
                                            <div className="orders-details">
                                                <div
                                                    className="orders-showItems"
                                                    onClick={() => toggleItems(order._id || index)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {expandedOrders[order._id || index] ? 'Hide Items' : 'Show Items'}
                                                </div>
                                                {expandedOrders[order._id || index] && (
                                                    <div className="orders-lists">
                                                        {order.orders.map((item, idx) => (
                                                            <div key={idx} className="order-item">
                                                                <div><strong>Item Name:</strong> {item.name || 'N/A'}</div>
                                                                <div><strong>Quantity:</strong> {item.Quantity || 0}</div>
                                                                <div><strong>Price:</strong> Rs. {item.price || 0}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className="space-20px"></div>
            </div>


        </>
    );

}
